module.exports = __webpack_public_path__ + "img/Parent Names.bd4f4ba7.svg";